import { useState } from 'react'
import type { FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { api, ApiError } from '@/api'
import { routes } from '@/routes'
import { AuthCard } from '@/components/auth/AuthCard'
import { Alert } from '@/components/ui/Alert'
import { Button } from '@/components/ui/Button'
import { TextField } from '@/components/ui/Field'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle' | 'submitting' | 'sent'>('idle')
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    setError(null)
    setStatus('submitting')

    try {
      await api.auth.requestPasswordReset(email)
      setStatus('sent')
    } catch (err) {
      setStatus('idle')
      setError(
        err instanceof ApiError ? err.message : 'Não foi possível enviar o e-mail.',
      )
    }
  }

  return (
    <AuthCard
      title="Recupere sua senha abaixo"
      description="Informe abaixo o e-mail da conta que deseja recuperar a senha e enviaremos as informações para ele."
    >
      {status === 'sent' ? (
        <div className="flex flex-col gap-4">
          {/* Resposta genérica de propósito: não revela se o e-mail existe. */}
          <Alert tone="success">
            Se existir uma conta com <strong>{email}</strong>, o link de recuperação chega
            em instantes. Confira também a caixa de spam.
          </Alert>
          <Link
            to={routes.login}
            className="py-1 text-center text-sm font-semibold text-brand hover:underline"
          >
            Voltar para o login
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4" noValidate>
          {error && <Alert tone="danger">{error}</Alert>}

          <TextField
            label="E-mail"
            type="email"
            name="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />

          <Button type="submit" size="lg" block loading={status === 'submitting'}>
            Enviar e-mail
          </Button>

          <Link
            to={routes.login}
            className="py-1 text-center text-sm text-ink-soft transition-colors hover:text-ink"
          >
            Cancelar
          </Link>
        </form>
      )}
    </AuthCard>
  )
}
